import { formReducer, modelReducer } from 'react-redux-form'
import { combineReducers } from 'redux'

import * as actions from '../../actions/admin/adminUserActions'
import * as h2Api from '../../h2Api'

const initialFormState = {
  userId: ''
}

export default combineReducers({
  state: (state = {}, action) => {
    if (action.type === actions.BEGIN_COMBINE_USERS) {
      return {
        ...state,
        user: action.user
      }
    }

    return state
  },
  combineRequest: h2Api.restReducer(actions.COMBINE_USERS),
  form: modelReducer('admin.users.combine.form', initialFormState),
  forms: formReducer('admin.users.combine', { form: initialFormState })
})
